import React, { Component, Fragment, createRef } from "react";
import AppContext from "../../contexts/AppContext";
import StepsHeader from "./include/StepsHeader";
import CheckoutSteps from "./include/CheckoutSteps";
import { checkToken, updateUserWithToken } from "../../services/user";

export class AccountDetail extends Component {	
	
	state = {
        validToken: true,
        item: {
            password: '',
            token_type: 'pwonbs1'
        },
        errors: {},
        loading: false,
        step: 'account',
    };

    componentDidMount() {
        checkToken({ token: this.props.match.params["token"], type: 'pwonbs1' })
            .then(res => {
                if (res.status === true) {
                    this.setState({
                        item: res.data,                        
                    });                    
                } else {
                    this.setState({ validToken: false });
                }
            })
            .catch(error => {
                this.setState({ validToken: false });
            });
    }

    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    };
    handleValidation = () => {
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;       

        if(!fields.password){
            formIsValid = false;
            errors.password = "The password field is required.";
		}  
		 
        this.setState({errors: errors});        
        return formIsValid;
    } 
    submitPassword = e => {
        e.preventDefault();        
        if(this.handleValidation())
        {
            this.state.item['step'] = this.state.step;
            this.setState({loading: true});  
            updateUserWithToken(this.state.item, this.props.match.params["token"])
            .then(res => {
				this.setState({loading: false}); 
				//this.context.state.showCodeMessage(res.message,'success'); 
                if (res.meta.token) {
					this.props.history.push('/process/personal-details/' + res.meta.token);                    
                }
            })
            .catch(error => {
				this.setState({loading: false}); 				
                this.context.state.handelError(error);
            });
        }
    };

	render() {
		
		return (
            <Fragment>
                        <div className="account-wrapper">
                            <StepsHeader></StepsHeader>
                            <section className="checkout pb-5">
                                <div className="container position-relative">
                                    <CheckoutSteps onboardStep="[1]" show="1"></CheckoutSteps>						
                                    <div className="create-profile mx-auto mb-3">    
                                        <h3 className="mb-2 text-md-center">Create Your Profile:</h3>
                                        <p className="mb-4 text-md-center text-dark">This will be your Member login credentials.</p>				    	    		
                                        <form method="POST">
                                            <div className="form-group mb-4">                                                        
                                                <input type="text"  className="form-control px-4" name="email" id="email" value={ this.state.item.email } readOnly ref="email" placeholder="Email" autoComplete="off" />                                                        
                                            </div>
                                            <div className="form-group mb-4">                                                        
                                                <input type="password"  className="form-control px-4" value={ this.state.item.password } onChange={this.onChange} name="password" id="password" ref="password" placeholder="Password" autoComplete="off" />   
                                                {this.state.errors
                                                        .password ? (
                                                    <div className="invalid-feedback">
                                                        {
                                                            this.state
                                                                .errors
                                                                .password
                                                        }
                                                    </div>
                                                ) : null}                                                     
                                            </div>
                                        </form>
                                    </div>
                                    <hr className="my-5"/>
                                    <button type="button" onClick={this.submitPassword} disabled={this.state.loading} className="btn d-block mx-auto continue btn-primary border-0"><i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : null}></i> {this.state.loading ? `Processing...` : `Continue`}</button>							
                                </div>		
                            </section>
                        </div>
                    </Fragment>
        );
    }
}

AccountDetail.contextType = AppContext;
export default AccountDetail;



// WEBPACK FOOTER //
// ./src/components/general/AccountDetail.js